import PropTypes from "prop-types";
import { useState } from "react";

import {
  Button,
  IconButton,
  MenuItem,
  TableCell,
  TableRow,
} from "@mui/material";
import { ViewGuard } from "src/auth/MyAuthGuard";
import ConfirmDialog from "src/components/confirm-dialog";
import Iconify from "src/components/iconify";
import MenuPopover from "src/components/menu-popover";
import AssessmentTableColumn from "src/config/AssessmentTableColumn.config";
import { formateDate } from "src/utils";
// ----------------------------------------------------------------------

AssessmentTableRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
  onAddScore: PropTypes.func,
  onDeleteRow: PropTypes.func,
  onViewRow: PropTypes.func,
  hideActions: PropTypes.bool,
};

export default function AssessmentTableRow({
  row,
  selected,
  onViewRow,
  onAddScore,
  onDeleteRow,
  hideActions = false,
}) {
  const [openPopover, setOpenPopover] = useState(null);

  const [openConfirm, setOpenConfirm] = useState(false);

  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };
  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell align="left">{row.title ?? "-"}</TableCell>
        <TableCell align="left">{row.subject_code ?? "-"} </TableCell>
        <TableCell align="left">{AssessmentTableColumn[row.group]}</TableCell>
        <TableCell align="left" sx={{ textTransform: "capitalize" }}>
          {formateDate(row.date_of_assessment, { withTime: false })}
        </TableCell>
        {!hideActions && (
          <TableCell align="left">
            <IconButton
              color={openPopover ? "inherit" : "default"}
              onClick={handleOpenPopover}
            >
              <Iconify icon="eva:more-vertical-fill" />
            </IconButton>
          </TableCell>
        )}
      </TableRow>

      {!hideActions && (
        <MenuPopover
          open={openPopover}
          onClose={handleClosePopover}
          arrow="right-top"
          sx={{ width: 140 }}
        >
          <MenuItem
            onClick={() => {
              handleClosePopover();
            }}
            disabled
          >
            <Iconify icon="material-symbols:compare-arrows" />
            Compare
          </MenuItem>

          <MenuItem
            onClick={() => {
              onAddScore();
              handleClosePopover();
            }}
          >
            <Iconify icon="hugeicons:edit-01" />
            Add Score
          </MenuItem>

          <ViewGuard permission="home.student.assessment.delete">
            <MenuItem
              onClick={() => {
                handleOpenConfirm();
                handleClosePopover();
              }}
            >
              <Iconify icon="fluent-mdl2:delete" />
              Delete
            </MenuItem>
          </ViewGuard>
        </MenuPopover>
      )}

      <ConfirmDialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        title="Delete"
        content="Are you sure want to delete?"
        action={
          <Button
            variant="contained"
            color="error"
            onClick={() => onDeleteRow(row.id, handleCloseConfirm)}
          >
            Delete
          </Button>
        }
      />
    </>
  );
}
